"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _paymentSettingsFormValidation = require("utils/paymentSettingsFormValidation");

var _recompose = require("recompose");

var _paymentErrorMessage = require("utils/paymentErrorMessage");

var _paymentErrorMessage2 = _interopRequireDefault(_paymentErrorMessage);

var _PaymentSettingForm = require("./components/PaymentSettingForm");

var _PaymentSettingForm2 = _interopRequireDefault(_PaymentSettingForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentSettingsFormContainer = function PaymentSettingsFormContainer(props) {
  return _react2.default.createElement(_PaymentSettingForm2.default, {
    nextCharge: props.nextCharge,
    paypalContainerId: props.paypalContainerId,
    paypalEmail: props.paypalEmail,
    paypalConfirmationHelpText: props.paypalConfirmationHelpText,
    fields: props.fields,
    error: (0, _paymentErrorMessage2.default)(props._error),
    message: props.message,
    existingMethod: props.existingMethod,
    handleSubmit: props.handleSubmit,
    updating: props.updating,
    paypalIconSrc: "/icons/pay-with-paypal.png",
    paypalNonce: props.paypalNonce,
    paymentLogosSrc: props.paymentLogosSrc,
    braintreeLink: props.braintreeLink,
    onCancelSubscriptionClick: props.onCancelSubscriptionClick,
    renderCaptcha: props.renderCaptcha,
    paypalPaymentBoxError: props.paypalPaymentBoxError,
    creditCardPrepare: props.creditCardPrepare
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["paymentMethod", "captcha"],
  form: "checkout",
  validate: _paymentSettingsFormValidation.validate
})((0, _recompose.lifecycle)({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.fields.paymentMethod.value === "cc" && nextProps.fields.paymentMethod.value === "paypal") {
      if (this.props.onPayPalPrepare) {
        this.props.onPayPalPrepare();
      }
    }
    if (nextProps.fields.paymentMethod.value == "cc") {
      this.props.setCreditCardState();
    }
  }
})(PaymentSettingsFormContainer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentSettingsForm/PaymentSettingsForm.jsx
// module id = 2819
// module chunks = 0